import React, {useEffect} from "react";
import "./assets/style/misc/App.scss";
import Navbar from "./components/Navbar";
import Main from "./components/Main";
import Footer from "./components/Footer";
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

function App() {
    return (
        <div className="App h-100">
          <Navbar />
          <Main />
          <Footer />
          <ScrollToTop/>
        </div>
    );
}

export default App;